document.addEventListener('DOMContentLoaded', function () {
  if (!window.mz) {
    return;
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  function closeSearch() {
    $('body').removeClass('open_search_mobile');
  }
  function afterUpdate() {
    // placeholder
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate);
  }
  if (mz.suggest && mz.suggest.$bus) {
    mz.suggest.$bus.on('run-query', closeSearch);
  }
});
